import React, { useState, useEffect, useRef } from 'react'
import { Provider } from 'react-redux'

import { dispatchCustomEvent } from '../../../shared/utils/events.js'

import store from './store.js'
import { resetWizardState } from './ducks/wizard.js'
import { loadMetaData, apiEndpoint } from './ducks/rails.js'

import DocumentUploadContainer from './components/document_upload_container.jsx'
import UploadButton from './components/upload_button.jsx'

const BusinessContinuityDocumentUploadApp = (props) => {
  const [currentlyUploadingFiles, setCurrentlyUploadingFiles] = useState(false);
  const [unpersistedFiles, setUnpersistedFiles] = useState([]);

  useEffect(() => {
    store.dispatch({
      type: 'INITIAL_LOAD_OF_DATA_FROM_RAILS',
      actions: [
        loadMetaData(props.meta),
      ]
    });
  }, []);

  var finishUploadingFiles = () => {
    setCurrentlyUploadingFiles(false);
    notifyOnUploadSuccess();
    store.dispatch(resetWizardState());
  }
  

  var cancelUploadingFiles = () => {
    setCurrentlyUploadingFiles(false);
  }

  var handleChooseFiles = (files) => {
    let filesArray = Array.from(files)

    setCurrentlyUploadingFiles(true);
    setUnpersistedFiles(filesArray);
  }

  var notifyOnUploadSuccess = () => {
    dispatchCustomEvent(null, 'business_continuity:uploaded')
  }

  return (
    <Provider store={ store }>
      <div>
        <UploadButton
          handleChooseFiles={ handleChooseFiles } />

        {
          currentlyUploadingFiles &&
            <DocumentUploadContainer
              files={ [...unpersistedFiles] }
              finishUploadingFiles={ finishUploadingFiles }
              cancelUploadingFiles={ cancelUploadingFiles }
            />
        }
      </div>
    </Provider>
  )
}

export default BusinessContinuityDocumentUploadApp;
